import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer id="footer" className="bg-[#2E492A] text-white py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-16 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-8">
          {/* Brand Section */}
          <div className="text-center md:text-left">
            <h3 className="font-['Playfair_Display_SC'] text-2xl md:text-3xl font-extrabold mb-4">
              Lotus Story
            </h3>
            <div className="flex justify-center md:justify-start gap-4 mt-4">
              <a href="https://www.instagram.com/lotustory.restaurant/" target="_blank" rel="noopener noreferrer" className="hover:opacity-80">
                <img src="https://cdn-icons-png.flaticon.com/512/1384/1384015.png" alt="Instagram" className="w-5 h-5 md:w-6 md:h-6 invert" />
              </a>
              <a href="https://www.instagram.com/lotustory.restaurant/" target="_blank" rel="noopener noreferrer" className="hover:opacity-80">
                <img src="https://cdn-icons-png.flaticon.com/512/1384/1384005.png" alt="Facebook" className="w-5 h-5 md:w-6 md:h-6 invert" />
              </a>
            

            </div>
          </div>

          {/* Shop Links */}
          <div className="text-center md:text-left">
            <h3 className="font-['Playfair_Display_SC'] text-2xl md:text-3xl font-extrabold mb-4">Shop</h3>
            <ul className="space-y-2 font-['Outfit'] text-sm md:text-base">
              <li><Link to="/" className="hover:opacity-80">Home</Link></li>
              <li><Link to="/about" className="hover:opacity-80">About</Link></li>
              <li><Link to="/menu" className="hover:opacity-80">Menu</Link></li>
              <li><Link to="/gifts" className="hover:opacity-80">Gifts</Link></li>
              <li><Link to="/whatson" className="hover:opacity-80">What's On</Link></li>
              <li><Link to="/reservation" className="hover:opacity-80">Reservation</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-center md:text-left">
            <h3 className="font-['Playfair_Display_SC'] text-2xl md:text-3xl font-extrabold mb-4">Get in touch</h3>
            <ul className="space-y-2 font-['Outfit'] text-sm md:text-base">
              <li>0449 626 583</li>
              <li>lotustoryrestaurant@gmail.com</li>
              <li>Address: 83 Melbourne St, North Adelaide 5006</li>
              <li className="mt-4 pt-4 border-t border-white/20">
                <p className="font-bold mb-2">Opening Hours:</p>
                <p>Open 7 days</p>
                <p>Lunch: 10:30AM - 2:30PM</p>
                <p>Dinner: 5:00PM - 9:00PM</p>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-8 border-t border-white/20 text-xs md:text-sm font-['Outfit'] text-center md:text-left">
          Lotus Story © 2023. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
